import { computed } from 'vue';

import Designation from '@/enums/Designation';
import { i18n } from '@/i18n';

export default function usePartnerHelpers(partner) {
  const isVet = computed(() => partner.designation === Designation.Veterinarian);

  const fullName = computed(() => `${isVet.value ? `${i18n.t('app.dr')} ` : ''}${partner.first_name} ${partner.last_name}`);

  const fullDesignation = computed(() => [
    isVet.value
      ? i18n.t('vetster.veterinarian')
      : i18n.t('vetster.veterinary-technician'),
    partner.post_nominal,
  ].filter(Boolean).join(', '));

  return {
    fullDesignation,
    fullName,
  };
}
